import $ from 'jquery';
import Bookmark from './bookmark';

import httpStatus from '../http-status';
import { login } from '../utils';

class BookmarkButton {
	constructor(id) {
		this.bookmark = new Bookmark();
		this.on = false;
		this.id = id;
		this.path = location.pathname;
	}

	async toggle() {
		try {
			if (this.on)
				await this.bookmark.delete(this.path);
			else
				await this.bookmark.add(this.path);
		} catch (e) {
			if (e.status === httpStatus.UNAUTHORIZED) {
				login();
			}

			return;
		}

		this.on = !this.on;
		this.update();
	}

	update() {
		if (this.on) {
			this.elements.ico.addClass('ico_bookmark--on');
			this.elements.text.html('북마크 추가됨');
		} else {
			this.elements.ico.removeClass('ico_bookmark--on');
			this.elements.text.html('북마크 추가되지 않음');
		}
	}

	async init() {
		try {
			const data = await this.bookmark.load(this.path);
			this.on = data.isExists;
		} catch {
			this.on = false;
		}

		const btn = $(this.id);
		this.elements = {
			text: btn.find('.sr_only'),
			ico: btn.find('.ico_bookmark')
		};

		this.update();

		btn.on('click', (event) => this.toggle(event));
	}
}

// export { BookmarkButton };
window.BookmarkButton = BookmarkButton;
